/**
 *
 *  ScrollToTopOnMount
 *  Component
 *
 *  Created by Vladimir Shishlyannikov on 14/04/2023.
 *  Copyright (c) 2023-present iWoo Ltd. All rights reserved.
 */

import { useEffect } from "react";

export default function ScrollToTopOnMount() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return null;
}
